import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
//import menu from './menu-dropdown';
import menu from './menu-overlay';
// Animations
import 'animate.css';

// Animations on scroll
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

Alpine.data('menu', menu);
Alpine.plugin(focus);
window.Alpine = Alpine;
window.Alpine.start();
